import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import api, { CarrierProfile } from '../lib/api'
import PremiumHeader from '../components/PremiumHeader'

export default function CarriersPage() {
  const [items, setItems] = useState<CarrierProfile[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [q, setQ] = useState('')

  const load = async (query?: string) => {
    setLoading(true)
    setError(null)
    try {
      const res = await api.carriers.list({ q: query || undefined })
      setItems(res.data)
    } catch (err: any) {
      setError(err?.response?.data?.error ?? 'Failed to load carriers')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    void load()
  }, [])

  return (
    <div className="max-w-6xl mx-auto p-6 space-y-4">
      <PremiumHeader
        title="Carrier Network"
        subtitle="Manage carrier partners, driver coverage, equipment, and assignment readiness."
        primaryAction={
          <Link to="/carriers/new" className="px-3 py-2 rounded bg-blue-700 text-white text-sm">New Carrier</Link>
        }
      />

      <form
        className="flex gap-2"
        onSubmit={(e) => {
          e.preventDefault()
          void load(q)
        }}
      >
        <input className="border rounded px-3 py-2 text-sm w-full" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search carriers..." />
        <button className="border rounded px-3 py-2 text-sm">Search</button>
      </form>

      {error && <div className="border border-red-200 bg-red-50 text-red-700 px-3 py-2 rounded text-sm">{error}</div>}
      {loading ? <div className="text-sm text-gray-500">Loading carriers...</div> : null}

      {!loading && !items.length ? <div className="text-sm text-gray-500">No carriers found.</div> : null}

      <div className="bg-white border rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-left">
            <tr>
              <th className="px-3 py-2">Legal Name</th>
              <th className="px-3 py-2">DOT</th>
              <th className="px-3 py-2">MC</th>
              <th className="px-3 py-2">Compliance</th>
              <th className="px-3 py-2">Phone</th>
            </tr>
          </thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id} className="border-t">
                <td className="px-3 py-2"><Link className="text-blue-700" to={`/carriers/${c.id}`}>{c.legal_name}</Link></td>
                <td className="px-3 py-2">{c.dot_number ?? '-'}</td>
                <td className="px-3 py-2">{c.mc_number ?? '-'}</td>
                <td className="px-3 py-2">{c.compliance_status ?? c.approval_status ?? '-'}</td>
                <td className="px-3 py-2">{c.phone ?? '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
